import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const skeletonVariants = cva(
  "animate-pulse bg-neutral-200",
  {
    variants: {
      variant: {
        rectangular: "rounded-md",
        circular: "rounded-full",
        text: "rounded h-4",
      },
    },
    defaultVariants: {
      variant: "rectangular",
    },
  }
);

export const Skeleton = ({ className, variant, ...props }) => (
  <div className={cn(skeletonVariants({ variant, className }))} role="status" aria-label="Loading" {...props}>
    <span className="sr-only">Loading...</span>
  </div>
);

export const DashboardCardSkeleton = () => (
  <div className="border border-neutral-200 rounded-lg p-6 space-y-4">
    <Skeleton className="h-12 w-12" variant="circular" />
    <Skeleton className="h-4 w-3/4" />
    <Skeleton className="h-4 w-1/2" />
  </div>
);

export const TableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div className="space-y-2">
    {[...Array(rows)].map((_, rowIndex) => (
      <div key={rowIndex} className="flex gap-4">
        {[...Array(columns)].map((_, colIndex) => (
          <Skeleton key={colIndex} className="h-8 flex-1" />
        ))}
      </div>
    ))}
  </div>
);

export const FormSkeleton = ({ fields = 6 }) => (
  <div className="space-y-4">
    {[...Array(fields)].map((_, index) => (
      <div key={index} className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-10 w-full" />
      </div>
    ))}
  </div>
);
